import React, { useEffect, useRef } from "react";
import TopPlanElement from "./TopPlanElement";
import { useSelector } from "react-redux";
import MyPlanElement from "./MyPlanElement";
import { SimpleLoader } from "./sub/Loaders";

function MyPlanTreeCards(props) {
  const topPlanState = useSelector((state) => state.topPlanState.value);

  const BottomRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (
          entry.isIntersecting &&
          !props.loading &&
          props.planCount > props.data.length
        ) {
          props.setPage(props.page + 1);
          props.loadMore(props.page + 1);
        }
      });
    });
    observer.observe(BottomRef.current);

    return () => observer.disconnect();
  }, [props]);

  return (
    <>
      {props.data?.map((element, index) => (
        <React.Fragment key={element.planId}>
          {element.planLevelName === topPlanState ? (
            <div className="px-4">
              <TopPlanElement
                plans={props.data}
                data={element}
                handleDelete={props.handleDelete}
                handleEdit={props.handleEdit}
              />
            </div>
          ) : (
            <MyPlanElement
              data={element}
              handleDelete={props.handleDelete}
              handleEdit={props.handleEdit}
            />
          )}
          {index === props.data.length - 1 && <div ref={BottomRef} />}
        </React.Fragment>
      ))}
      {props.loading && <SimpleLoader />}
    </>
  );
}

export default MyPlanTreeCards;
